import { RawPhaseEvent } from '../../utils/type'
import { STATIC_DATA_STATES } from '../chart-components'

export interface PhaseErrors {
    intervention_id: boolean
    start?: boolean
    oD: boolean // in pol or cm
    prevCasingFinalMD: boolean
    prevCasingOD: boolean
    riser: boolean
}

export interface Errors {
    phase: PhaseErrors
    messages: { phase: string }
}

export const emptyPhaseErrors: PhaseErrors = {
    oD: false,
    intervention_id: false,
    prevCasingFinalMD: false,
    prevCasingOD: false,
    riser: false,
    start: false
}

export const getEmptyErrors = (): Errors => ({
    phase: { ...emptyPhaseErrors },
    messages: { phase: '' }
})

export const emptyRawPhaseEvent: RawPhaseEvent = {
    id: null,
    oD: { uom: null, value: null },
    startMD: { uom: null, value: null },
    end: null,
    finalMD: { uom: null, value: null },
    intervention_id: null,
    name: null,
    noPreviousCasingValue: false,
    prevCasingFinalMD: { uom: null, value: null },
    prevCasingOD: { uom: null, value: null },
    riser: null,
    state: STATIC_DATA_STATES.EMPTY,
    start: null,
    type: null
}
